// extracted by mini-css-extract-plugin
export default {"rowsWrapper":"CardLoader_rowsWrapper__i4IRg","loading":"CardLoader_loading__AXxYu","salmon":"CardLoader_salmon__g8add","gray":"CardLoader_gray__8PZRL"};